import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface Company {
    id: number,
    name: string,
    code?: string,
    email?: string,
    company_name : string,
}

interface FilterState {
    companyList: Company[]; 
    employeeName: string; 
    employeeCode: string; 
    month: { label: string; value: number }; 
    year: { label: string; value: number }; 
    employeeStatus: { label: string; value: string } | null; 
    disbursementStatus: { label: string; value: string } | null;
}

const initialState: FilterState = {
    companyList: [],
    employeeName: "",
    employeeCode: "",
    month: { label: "", value: 0 },
    // year: { label: `${new Date().getFullYear()}`, value: new Date().getFullYear() },
    year: { label: "", value: 0},
    employeeStatus: null,
    disbursementStatus: null,
};

const filterSlice = createSlice({
    name: "compensationFilters",
    initialState,
    reducers: {
        setCompanyList: (
            state,
            action: PayloadAction<any[]>
        ) => {
            state.companyList = action.payload;
        },
        updateEmployeeName: (state, action: PayloadAction<string>) => {
            state.employeeName = action.payload;
        },
        updateEmployeeCode: (state, action: PayloadAction<string>) => {
            state.employeeCode = action.payload;
        },
        updateMonth: (
            state,
            action: PayloadAction<{ label: string; value: number }>
        ) => {
            state.month = action.payload;
        },
        updateYear: (
            state,
            action: PayloadAction<{ label: string; value: number }>
        ) => {
            state.year = action.payload;
        },
        updateEmployeeStatus: (
            state,
            action: PayloadAction<{ label: string; value: string } | null>
        ) => {
            state.employeeStatus = action.payload;
        },
        updateDisbursementStatus: (
            state,
            action: PayloadAction<{ label: string; value: string } | null>
        ) => {
            state.disbursementStatus = action.payload;
        },
        resetFilters: (state) => {
            state.employeeName = "";
            state.employeeCode = "";
            state.month = { label: "", value: 0 };
            state.year = { label: "", value: 0 }; ;
            state.employeeStatus = null;
            state.disbursementStatus = null;
        },
        resetCompanyList: (state) => {
            state.companyList = [];
        }
    },
});

export const {
    setCompanyList,
    updateEmployeeName,
    updateEmployeeCode,
    updateMonth,
    updateYear,
    updateEmployeeStatus,
    updateDisbursementStatus,
    resetFilters,
    resetCompanyList,
} = filterSlice.actions;

export default filterSlice.reducer;
